import {
  addLogo,
  arrowBlueLeft,
  arrowBlueRight,
  arrowDown,
  arrowDownGray,
  arrowDownGreen,
  arrowDownInvited,
  arrowDownRed,
  attention,
  backIcon,
  check,
  checkValid,
  clearBlack,
  plusBlue,
  bluePencil,
  close,
  fi_arrow_up,
  cloudComputing,
  companies,
  edit,
  closeWhite,
  btnLoader,
  errorTrash,
  errorTriangle,
  eye,
  eyeOff,
  fi_help,
  iconSuccess,
  iSortAsc,
  iSortDesc,
  loader,
  logoBlue,
  logoDark,
  logoLight,
  logoutIcon,
  logoWhite,
  minus,
  planningCycle,
  plus,
  plusBlack,
  rotateCCW,
  savePng,
  search,
  searchGray,
  sortIcon,
  library,
  addCustomWidget,
  externalLink,
  square,
  vector,
  vectorActive,
  barChartBlack,
  boxBlack,
  trendingUpBlack,
  barChart,
  box,
  trendingUp,
  matraz,
  padlock,
} from "assets/icons";

export const getIconUtil = (iconName: string) => {
  const icons: Record<string, string> = {
    addLogo,
    arrowBlueLeft,
    arrowBlueRight,
    arrowDown,
    arrowDownGray,
    arrowDownGreen,
    arrowDownInvited,
    arrowDownRed,
    attention,
    backIcon,
    check,
    checkValid,
    clearBlack,
    plusBlue,
    bluePencil,
    close,
    fi_arrow_up,
    cloudComputing,
    companies,
    edit,
    closeWhite,
    btnLoader,
    errorTrash,
    errorTriangle,
    eye,
    eyeOff,
    fi_help,
    iconSuccess,
    iSortAsc,
    iSortDesc,
    loader,
    logoBlue,
    logoDark,
    logoLight,
    logoutIcon,
    logoWhite,
    minus,
    planningCycle,
    plus,
    plusBlack,
    rotateCCW,
    savePng,
    search,
    searchGray,
    sortIcon,
    library,
    addCustomWidget,
    externalLink,
    square,
    vector,
    vectorActive,
    barChartBlack,
    boxBlack,
    trendingUpBlack,
    barChart,
    box,
    trendingUp,
    matraz,
    padlock,
  };

  return icons[iconName] || "";
};

export const filterName = (subMenuName: any) => {
  if (typeof subMenuName === "string" && subMenuName.includes("§")) {
    const parts = subMenuName.split("§");
    return parts.length > 2 ? parts[2] : parts[1];
  }

  return subMenuName || "";
};
